import React, { useState, useRef, useContext, useEffect } from "react";
import axios from "axios";
import { Button, IconSettings } from "@salesforce/design-system-react";

import { MessagesContext } from "../context/messagesContext";
import { FormContext } from "../context/formContext";
import { AppContext } from "../context/appContext";

import Title from "./FormComponents/Title";
import SubTitle from "./FormComponents/SubTitle";
import Input from "./FormComponents/Input";
import Display from "./FormComponents/Display";
import Picklist from "./FormComponents/Picklist";
import Checkbox from "./FormComponents/Checkbox";
import Textarea from "./FormComponents/Textarea";
import Datepicker from "./FormComponents/Datepicker";
import Section from "./FormComponents/Section";
import Footer from "./FormComponents/Footer";
import CancelButton from "./FormComponents/CancelButton";
import ErrorAlert from "./ErrorAlert";

const FormBuilder = (props) => {
    const { jwt } = useContext(AppContext);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const {
        formData,
        setFormData,
        handleSubmit,
        handleReset,
        handleFormDataUpdate,
    } = useContext(FormContext);
    const [inputValue, setInputValue] = useState("");
    const [selection, setSelection] = useState([]);
    const [dateValue, setDateValue] = useState(undefined);
    const [refList, setRefList] = useState([]);

    const {
        pages,
        message,
        setPages,
        replacePage,
        setIsWorkspaceLoading,
    } = useContext(MessagesContext);

    const currentPage = pages[pages.length - 1];

    const setInitialFormData = () => {
        const initalFormData = Object.fromEntries(
            currentPage.mappings
                       .map((mapping, index) => {
                           let value;

                           if (currentPage.result) {
                               value = currentPage.result[mapping.name];
                           } else if (mapping.hootsuite_field) {
                               value = message[mapping.hootsuite_field];
                           }
                           if (value) return [mapping.name, value];
                       })
                       .filter((mapping) => mapping) // Strip empty
        );
        console.log("initalFormData", initalFormData);
        setFormData(initalFormData);
    };

    const addRef = () => {
        const newRef = useRef();
        setRefList((prefRefList) => [...prefRefList, newRef]);
        return newRef;
    };

    const handleSelect = (name, event, data) => {
        if (data) {
            let value = data.selection[0].label;
            handleFormDataUpdate(name, value);
        }
    };

    const createSaleforceObject = async (form_data) => {
        setIsError(false);
        setIsWorkspaceLoading(true);
        let data = {form_data}

        data.salesforce_type = currentPage.salesforce_type;
        data.jwt = jwt;
        data.message_id = message.id;

        if (currentPage.parent) {
            data.parent_id = currentPage.parent.id;
            data.parent_type = currentPage.parent.type;
        }

        console.log("Create");
        axios({
            method: "post",
            url: "/salesforce/api/salesforce_object",
            data: data,
        })
            .then((result) => {
                console.log(result);
                axios({
                    method: "get",
                    url: "/salesforce/api/salesforce_object",
                    params: {
                        jwt: jwt,
                        id: result.data.salesforce_id,
                        type: currentPage.salesforce_type,
                    },
                }).then((newPageResult) => {
                    replacePage(newPageResult.data);
                });
            })
            .catch((error) => {
                console.log("Error", error.response.data.error);
                setIsError(true);
                setErrorMessage(error.response.data.error);
            })
            .then(() => {
                // ensure
                setIsWorkspaceLoading(false);
            });
    };

    const updateSaleforceObject = async (form_data) => {
        setIsError(false);
        setIsWorkspaceLoading(true);

        let data = { form_data }

        data.salesforce_id = currentPage.result.Id;
        data.salesforce_type = currentPage.salesforce_type;
        data.jwt = jwt;
        data.message_id = message.id;
        console.log("Update");
        axios({
            method: "put",
            url: "/salesforce/api/salesforce_object",
            data: data,
        })
            .then((result) => {
                console.log(result);
                axios({
                    method: "get",
                    url: "/salesforce/api/salesforce_object",
                    params: {
                        jwt: jwt,
                        id: result.data.salesforce_id,
                        type: currentPage.salesforce_type,
                    },
                }).then((newPageResult) => {
                    replacePage(newPageResult.data);
                });
            })
            .catch((error) => {
                debugger;
                console.log("Error", error.response.data.error);
                setIsError(true);
                setErrorMessage(error.response.data.error);
            })
            .then(() => {
                // ensure
                setIsWorkspaceLoading(false);
            });
    };

    const fields = () => {
        if (!currentPage.mappings?.length) {
            return <div>No field mappings configured.</div>;
        }
        console.log("fields - formData", formData);

        let fieldMapping = currentPage.mappings.map((mapping, index) => {
            console.log("Mapping", mapping);
            const type = mapping.type == "string" ? "text" : mapping.type;
            console.log("currentPage", currentPage, "message", message);
            const value = formData[mapping.name];

            switch (type) {
                case "picklist":
                    return (
                        <Picklist
                            key={`${mapping.name}-${mapping.label}-${index}`}
                            name={mapping.name}
                            label={mapping.label}
                            options={mapping.options}
                            selected={value}
                            onUpdate={handleSelect}
                        />
                    );
                    break;
                case "textarea":
                    return (
                        <Textarea
                            key={`${mapping.name}-${mapping.label}-${index}`}
                            name={mapping.name}
                            label={mapping.label}
                            value={value}
                            required={mapping.required}
                            onChange={(event) => handleFormDataUpdate(mapping.name, event.target.value)}
                        />
                    );
                    break;
                case "date":
                    return (
                        <Datepicker
                            key={`${mapping.name}-${mapping.label}-${index}`}
                            name={mapping.name}
                            label={mapping.label}
                            value={value}
                            required={mapping.required}
                            onChange={(event, v) => handleFormDataUpdate(mapping.name, v.date)}
                        />
                    );
                    break;
                case "hidden":
                    return(null)
                    break;
                default:
                    return (
                        <Input
                            key={`${mapping.name}-${mapping.label}-${index}`}
                            label={mapping.label}
                            name={mapping.name}
                            type={type}
                            value={value}
                            required={mapping.required}
                            onChange={(event, data) =>
                                handleFormDataUpdate(mapping.name, data.value)
                            }
                        />
                    );
            }
        });

        return fieldMapping;
    };

    useEffect(() => {
        handleReset();
        setInitialFormData();
    }, [currentPage.salesforce_type]);

    return (
        <IconSettings iconPath="/icons">
            {isError ? <ErrorAlert message={errorMessage} /> : null}
            <form
                onSubmit={(e) =>
                    handleSubmit(
                        e,
                        currentPage.action == "new"
                        ? createSaleforceObject
                        : updateSaleforceObject
                    )
                }
            >
                <Title>{currentPage.title}</Title>
                <SubTitle>Object Information</SubTitle>
                <Section>{fields()}</Section>
                {!!currentPage.mappings.length && (
                     <Footer>
                         <CancelButton />
                         <Button
                             label={currentPage.action == "new" ? "Create" : "Update"}
                             type="submit"
                             variant="brand"
                         />
                     </Footer>
                )}
            </form>
        </IconSettings>
    );
};

export default FormBuilder;
